export default __webpack_public_path__ + "static/MD_SearchThumb_Cloud_Management-731f160f62e5709ccb334e794b8ad898.webp";